import angular from "angular";

import { Dashboard } from "../../gateway/Dashboard/Dashboard";
import { Serie } from "../../gateway/Serie/Serie";
import { Visualization } from "../../gateway/Visualization/Visualization";
import { PopulateManager } from "../../presentation/services/PopulateManager/PopulateManager";

export class ParameterizationSidenavService {
    PopulateManager = new PopulateManager();
    Serie = new Serie({ PopulateManager: this.PopulateManager });
    Visualization = new Visualization();
    Dashboard = new Dashboard({
        Visualization: this.Visualization,
        PopulateManager: this.PopulateManager
    });
    _sidenavInstance = null;
    componentId = "ParametrizationSideNav";
    seriesIdsToParameterize = [];
    serieNucontSelected = {};
    visualizations = [];
    visualizationSelected = null;
    isPopulate = false;
    companyData = null;
    isLoading = false;
    constructor($mdSidenav) {
        this.$mdSidenav = $mdSidenav;
    }

    init() {
        this.$mdSidenav(this.componentId, true).then((instance) => {
            this._sidenavInstance = instance;
        });
    }

    setIsPopulate(isPopulate) {
        this.isPopulate = isPopulate;
    }

    async open({ companyData, series } = {}) {
        this.isLoading = true;
        this.companyData = companyData;
        await this.populate({ companyData });
        const dependencies = this.getDependecies(series);
        const serieNucontSelected = this.Serie.findOneCollection({
            _id: dependencies[0]
        });
        this.seriesIdsToParameterize = dependencies;
        this.serieNucontSelected = serieNucontSelected || {};
        this.isLoading = false;
        this.$mdSidenav(this.componentId).open();
    }

    async populate({ companyData } = {}) {
        if (this.isPopulate) return;
        if (!companyData) return;
        const serieIds = await this.Dashboard.getByCompany({
            companyId: companyData._id,
            source: "accounting"
        });
        await Promise.all([
            this.Serie.getByCompanyDemand({
                companyId: companyData._id,
                seriesIds: [
                    ...serieIds,
                    "0j8a61hf52575ph8dlykj5",
                    "123eda408faa454bc1ab97ad",
                    "148h0kif80xab15hrswtwd",
                    "2xuXT2iB6HcnLtWpJ",
                    "32k232z732RjA53si",
                    "5f8eda328faa454bc1ab9793",
                    "5f8eda338faa454bc1ab9794",
                    "5f8eda338faa454bc1ab9795",
                    "5f8eda348faa454bc1ab9798",
                    "5f8eda358faa454bc1ab9799",
                    "5f8eda368faa454bc1ab979d",
                    "5f8eda388faa454bc1ab1234",
                    "5f8eda388faa454bc1ab979e",
                    "5f8eda398faa454bc1ab97a0",
                    "5f8eda398faa454bc1ab97a1",
                    "5f8eda3a8faa454123ab97a4",
                    "5f8eda3a8faa454bc1ab97a4",
                    "5f8eda3b8faa454bc1ab97a6",
                    "5f8eda408faa454bc1ab97ad",
                    "5f8eda428faa454bc1ab97ae",
                    "5f8eda438faa454bc1ab97b2",
                    "6opYXG5EraFBPHarK",
                    "6rkTDygAyhZyihQCu",
                    "7p2nnozxsuhajb1bz8oaaj",
                    "84pvalb5i9bk6bv8q412o",
                    "8ogxtgq01gx5ty1fu4u5fj",
                    "9xKvLndtymKTtrEKu",
                    "CQcv5kPLkkGYicNki",
                    "DBKakGZ3mrcpdP6K4",
                    "DUNuT2iB6HcnLtWpJ",
                    "FNx6nyQhmZXcYfDcW",
                    "HSMmg7zPFMtLqYWeK",
                    "IMkh8rKtwm24fSbso",
                    "KKAbsTLfPWnw8HgEo",
                    "KrZxGBCwkRbiwNgnf",
                    "PSGB9PtkkKzJxva64",
                    "Q6yCZKjjuPXrwRKov",
                    "Qfmph573HMafAhrB3",
                    "RahzmyHvmN5WeHywg",
                    "RkKQkGZ3mrcpdP6K4",
                    "UnjuT2iB6HcnLtWpJ",
                    "WNHdH9v89pYNPmipm",
                    "WnCTW4t2KJ84YiQng",
                    "XGeG4am6htTSSBQnE",
                    "YB2TFzSjpuNy5r64o",
                    "ZBG2D2a4KE5ktaLXj",
                    "abwT2iB6HcnLtWpJ",
                    "artiepWJcXjLEFqMs",
                    "bgQuT2iB6HcnLtWpJ",
                    "bm8NDzq6MYcMFdfSS",
                    "bq3YqBESapT2hQMy5",
                    "cvW6kjTvRwfNoRdqm",
                    "da88e1q02jn0cgo1p3cuns",
                    "e6p57xxkzuMPmrGnS",
                    "gp5iepWJcXjLEFqMs",
                    "h7T92Qn2e2kDLEtTb",
                    "hGpotMyDNLBbqkeCv",
                    "hPcbqBwM23n3v6XK2",
                    "hfou8dPoXsLxzjxuZ",
                    "hjl3zr2rs044wcflf9ne7e",
                    "hpgb0uphoqwd9kd6pnurs",
                    "hq9fnwy6xl4oc13w0vqcs",
                    "inKT2iB6HcnLtWpJ",
                    "j7BvjBM2e7swWffn9",
                    "n8qf76lro7qlenz0od32f",
                    "nbY5CLf7dx2MP8jgs",
                    "nq0yxcmu1xg23ueg36e474",
                    "oad2iB6HcnLtWpJ",
                    "omYuT2iB6HcnLtWpJ",
                    "pWHTErjQx9fZbDQSC",
                    "rntSbxy7KEEHhRx9P",
                    "sgvrds1r71e7yoph2aj4",
                    "uej6pxhwg3qncbdz1uoo4f",
                    "uomuT2iB6HcnLtWpJ",
                    "we0bgmiaelm6t9gmmpryvp",
                    "xFF8Dj9ToL6hDPQaF",
                    "xvWP5w3BzwFw3YNmq",
                    "y77jhuwtfn65aw99adew",
                    "yb7vLndtymKTtrEKu",
                    "yebTttyeHctLtypa",
                    "ynuXT2iB6tcnetbp3"
                ],
                needAudit: true,
                source: "accounting",
                dependentsKpi: true
            }),
            this.Serie.populateAccountsPlans({
                companyIds: [companyData._id],
                source: "accounting",
                rewrite: true,
                origin: "raw"
            })
        ]);
        this.isPopulate = true;
    }

    getDependecies(series) {
        let dependencies = [];
        for (const serie of series) {
            if (serie.dependency) {
                dependencies = dependencies.concat(serie.dependency);
            }
        }
        dependencies = _.uniq(dependencies);
        return dependencies;
    }

    setVisualizations(visualizations) {
        this.visualizations = visualizations;
    }

    setVisualizationSelected(visualization) {
        this.visualizationSelected = visualization;
    }

    isOpen() {
        return this._sidenavInstance.isOpen();
    }

    close() {
        this.seriesIdsToParameterize = [];
        this.serieNucontSelected = {};
        this.visualizationSelected = null;
        this.$mdSidenav(this.componentId).close();
    }
}

angular.module("nucont.shared")
    .service("ParameterizationSidenavService", [
        "$mdSidenav",
        ParameterizationSidenavService
    ]);
